/* eslint-disable jsx-control-statements/jsx-use-if-tag */
import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Cross from './BlueCross.svg'

const Chip = ({
  isSelected,
  onClick,
  title,
  icon,
  showCross,
  className,
  onCrossClick,
  refKey
}) => {
  return (
    <div
      className={classNames(
        'br-100 flex flex-middle flex-center h-8 chipProp',
        {
          'nudge-bg-color c-blue bg-blue-100': isSelected,
          'px-3': !className,
          [className]: className
        }
      )}
      style={{ border: isSelected ? 'solid 1px #36c' : 'solid 1px #D8D8D8' }}
      onClick={onClick}
      ref={refKey}
    >
      {icon ? <div className="flex flex-middle h-6 mr-2">{icon}</div> : ''}
      <div className="fs-3 fw-500 lh-24">{title}</div>
      {showCross && isSelected ? (
        <div
          className="flex flex-middle h-6 ml-2"
          onClick={e => {
            e.stopPropagation()
            onCrossClick()
          }}
        >
          <Cross />
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

Chip.propTypes = {
  isSelected: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string
}

Chip.defaultProps = {
  isSelected: false,
  onClick: () => {},
  title: ''
}

export default Chip
